module.exports = __webpack_public_path__ + "media/images/hjv-logo-fee79b80109e1c38677301d74cb89f0b.svg";